import useSWR from 'swr';
import { getData } from '@apis/rest-client';

const reviewLogUrl = 'CentralMonitoring/ReviewLog';

const ReviewLogApi = {
    useGetDecisionLOVIsUsed: (lovRef: string, enabled: boolean) => {
        return useSWR<boolean>(enabled ? `${reviewLogUrl}/DecisionLOVUsed/${lovRef}` : null, getData);
    },
};

export default ReviewLogApi;
